import React from 'react';

import { JobData } from '../../../hooks/useMockJobData';

interface AccordionControlProps {
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

interface AccordionProps extends AccordionControlProps {
  jobData: JobData;
}

export const withAccordionControl = <P extends AccordionProps>(
  Component: React.ComponentType<P>,
): React.FC<P> => {
  return ({ expanded, onChange, ...props }: P) => {
    return (
      <Component expanded={expanded} onChange={onChange} {...(props as P)} />
    );
  };
};
